export enum TFSStatus {
	Pending = "Pending",
	Future = "Future",
	Upcoming = "Upcoming",
	Active = "Active",
	Expired = "Expired",
	Closed = "Closed",
}

const statusColors: Record<TFSStatus, string> = {
	[TFSStatus.Pending]: "#dcf4f8",
	[TFSStatus.Future]: "#ffffff",
	[TFSStatus.Upcoming]: "#f9ffc0",
	[TFSStatus.Active]: "#c8ffc1",
	[TFSStatus.Expired]: "#ffe4b5",
	[TFSStatus.Closed]: "#ffd9d9",
}

export function getTFSStatusColor(status: TFSStatus) {
	return statusColors[status]
}
